export default {
  /**
   *
   * @param state
   * @param property
   * @param payload
   */
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  resetForm(state) {
    state.form = {
      name: '',
      driver_id: '',
      event_end: '',
      event_start: '',
      push_notification_channel: 0,
      email_channel: 0,
      web_page_channel: 0,
      web_pages: [],
      // message_template_id: '',
      max_product_to_send: 5,
      active: 1,
    }
  }
};
